/** We can sometimes have incorrect country codes in our brands, so we map them to the right one */
export const getIsoCountryCode = (countryCode: string | null): string | null => {
	if (!countryCode) return null

	switch (countryCode.toLowerCase()) {
		case 'uk':
			return 'gb'
		default:
			return countryCode
	}
}
